import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-xhr-backend';
import { initReactI18next } from 'react-i18next';

import DE from './translations/de.json';
import EN from './translations/en.json';
import ES from './translations/es.json';
import FR from './translations/fr.json';
import IT from './translations/it.json';
import PT from './translations/pt.json';

const resources = { EN, DE, ES, IT, FR, PT };

export const availableLanguages = Object.keys(resources);

i18n
  .use(initReactI18next)
  .use(LanguageDetector) // try to detect user's language
  .use(Backend) // lazy load translation using xhr from /public/locales
  .init({
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator'],
      lookupQuerystring: 'lang',
    },
    debug: false,
    resources,
    fallbackLng: 'EN',
    supportedLngs: availableLanguages,
  });

export default i18n;
